import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as um from './util-misc.mjs'
import * as us from './util-sel.mjs'

// Used to contain more logic. May remove later.
export function mainShortCats(val) {return a.laxStruct(val).mainShortCategories}
export function concernShortCats(val) {return a.laxStruct(val).concernShortCategories}

// TODO generalize.
export function catsToString(val) {return a.joinOptLax(um.getTitles(val), `, `)}

export function catSelTitles(sels, vals) {
  if (a.isEmpty(vals)) return undefined
  return um.getTitles(us.selsByVals(sels, vals))
}

export function compareByTotalCount(one, two) {
  one = a.optFin(one.getTotalCount())
  two = a.optFin(two.getTotalCount())

  if (a.isNil(two)) return -1
  if (a.isNil(one)) return 1

  if (one > two) return -1
  if (one < two) return 1
  return 0
}

export function getTotalCount(val) {return val.getTotalCount()}

export function catHasDepthMain(val) {return val.depth === c.CATEGORY_DEPTH_MAIN}
